import { Breadcrumb, BreadcrumbItem } from '@/components/Breadcrumbs';
import {
  BillingDetailsEditPath,
  BillingHomePath,
  BillingInvoiceDetailsPath,
  BillingInvoiceListPath,
  BillingPaymentMethodAddPath,
  BillingPaymentMethodListPath,
  BillingUpgradePlanPath,
  BillingUpgradePlanPaymentSetupPath,
} from '@/modules/billing/paths';
import productBreadcrumbs from '@/modules/product/breadcrumbs';
import {
  ProductImportPath,
  ProductListListPath,
  ProductListPath,
  ProductListProductAddPath,
  ProductListProductListPath,
} from '@/modules/product/paths';
import {
  CustomerAddPath,
  CustomerEditPath,
  CustomerListPath,
  CustomerStoreAddPath,
  CustomerStoreEditPath,
  CustomerStoreListPath,
  SupplierHomePath,
  SupplierSettingsPath,
} from '@/modules/supplier/paths';

const home = { label: 'Home', path: SupplierHomePath };
const settings = { label: 'Settings', path: SupplierSettingsPath.profile };
const customers = { label: 'Customers', path: CustomerListPath };
const customer = { label: 'Customer', path: CustomerEditPath.path };
const stores = { label: 'Stores', path: CustomerStoreListPath.path };
const billing = { label: 'Billing', path: BillingHomePath };
const invoices = { label: 'Invoices', path: BillingInvoiceListPath };
const paymentMethods = { label: 'Payment Methods', path: BillingPaymentMethodListPath };
const upgrade = { label: 'Upgrade Plan', path: BillingUpgradePlanPath };

const entry = (path: string, label: string, parents: BreadcrumbItem[] = []): Breadcrumb => ({
  path,
  items: [home, settings, ...parents, { label, path }],
});

const breadcrumbs: Breadcrumb[] = [
  entry(SupplierSettingsPath.profile, 'Profile'),
  entry(SupplierSettingsPath.address, 'Business Address'),
  entry(SupplierSettingsPath.businessAddress, 'Business Address'),
  entry(SupplierSettingsPath.currency, 'Currency'),
  entry(SupplierSettingsPath.language, 'Language'),
  entry(SupplierSettingsPath.notification, 'Notifications'),
  entry(SupplierSettingsPath.password, 'Change Password'),
  entry(CustomerListPath, 'Customers'),
  entry(CustomerAddPath, 'Create Customer', [customers]),
  entry(CustomerEditPath.path, 'Edit Customer', [customers]),
  entry(CustomerStoreListPath.path, 'Stores', [customers, customer]),
  entry(CustomerStoreAddPath.path, 'Add Store', [customers, customer, stores]),
  entry(CustomerStoreEditPath.path, 'Edit Store', [customers, customer, stores]),
  ...productBreadcrumbs.map(({ path, items }) => ({
    path,
    items: [home, settings, ...items.slice(1)],
  })),
  entry(ProductImportPath, 'Import Products', [{ label: 'Products', path: ProductListPath }]),
  entry(ProductListProductAddPath.path, 'Add Products', [
    { label: 'Product Lists', path: ProductListListPath },
    { label: 'Products in List', path: ProductListProductListPath.path },
  ]),
  entry(BillingHomePath, 'Billing'),
  entry(BillingInvoiceListPath, 'Invoices', [billing]),
  entry(BillingInvoiceDetailsPath.path, 'Invoice Details', [billing, invoices]),
  entry(BillingDetailsEditPath, 'Edit Billing Details', [billing]),
  entry(BillingUpgradePlanPath, 'Upgrade Plan', [billing]),
  entry(BillingUpgradePlanPaymentSetupPath, 'Payment Setup', [billing, upgrade]),
  entry(BillingPaymentMethodListPath, 'Payment Methods', [billing]),
  entry(BillingPaymentMethodAddPath, 'Add Payment Method', [billing, paymentMethods]),
];

export default breadcrumbs;
